import React from "react";
import "./VehicleRecords.css";

export default function VehicleRecords({ vehicles, selectedVehicle, vehicleDetails, loading, handleVehicleSelection }) {
  console.log("vehicles", vehicles);
  console.log("selectedVehicle", selectedVehicle);
  console.log("vehicleDetails", vehicleDetails);
  console.log("loading", loading);
  console.log("handleVehicleSelection", handleVehicleSelection);
  return (
    <div className="vehicle-records-page">
      <br />
      <h2 className="title">Vehicle Records</h2>

      {/* Dropdown to select a vehicle */}
      <div className="dropdown-container">
        <select className="circuit-dropdown" onChange={(e) => handleVehicleSelection(e.target.value)} defaultValue="">
          <option value="" disabled>
            Select a Vehicle
          </option>
          {vehicles.map((vehicle) => (
            <option key={vehicle.id} value={vehicle.id}>
              {vehicle.name}
            </option>
          ))}
        </select>
      </div>

      {/* Loader */}
      {loading && (
        <div className="socket">
          <div className="gel center-gel">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c1 r1">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          {/* Add remaining divs for the loader as per your loader structure */}
        </div>
      )}

      {/* No laps recorded message */}
      {!loading && selectedVehicle && vehicleDetails.length === 0 && <div style={{ color: "#FF4600", textAlign: "center" }} className="no-records-message">No laps recorded</div>}

      {/* Table for displaying vehicle details */}
      {!loading && vehicleDetails.length > 0 && (
        <div className="vehicle-details">
          <h3>Vehicle Record Details</h3>
          <table>
            <thead>
              <tr>
                <th>Circuit</th>
                <th>Driver</th>
                <th>Time</th>
                <th>Date</th>
                <th>Venue</th>
              </tr>
            </thead>
            <tbody>
              {vehicleDetails.map((result, index) => (
                <tr key={index}>
                  <td>{result.circuitName}</td>
                  <td>
                    <a href={`/driver/${result.customerId}`} className="driver-link">
                      {result.customerName}
                    </a>
                  </td>
                  <td>{result.lapTimeStr}</td>
                  <td>{new Date(result.date).toLocaleDateString()}</td>
                  <td>{result.venueName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
